import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Grid, Button, Input, TextField } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Autocomplete from '@mui/material/Autocomplete';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { filter } from 'lodash';

const MySwal = withReactContent(Swal);

const showDuplicateEntryAlert = () => {
    MySwal.fire({
        title: <strong>Item Parameter Not Found</strong>,
        html: <p>In Quality Check Master, Parameter's are not defined</p>,
        icon: 'info',
        confirmButtonColor: '#1976d2',
        confirmButtonText: 'OK',
    });
};

function QualityCheckEntry(props) {
    const [ShowEntries, setShowEntries] = useState(true);

    const [EntryNo, setEntryNo] = useState(0);
    const [Flag, setFlag] = useState('');
    const [QcCode, setQcCode] = useState(0);
    const [TrDate, setTrDate] = useState(getCurrentDate());
    const [Manufacture, setManufacture] = useState('');
    const [Expiry, setExpiry] = useState('');
    const [BatchNo, setBatchNo] = useState('');
    const [Narration, setNarration] = useState('');
    const [Qty, setQty] = useState(0);
    const [Weight, setWeight] = useState(0);
    const [GRNEntryNo, setGRNEntryNo] = useState(0);
    const [QcItCode, setQcItCode] = useState(0);
    const [QualityCheck, setQualityCheck] = useState(0);
    const [rows, setRows] = useState([{ Parameter: '', StartValue: '', Endvalue: '', ActualValue: '', Remark: '' }]);
    const [DeptCode, setDeptCode] = useState('');
    const [UserID, setUserID] = useState('');
    const [units, setUnits] = useState([]);
    const [EmpCode, setEmpCode] = useState('');

    const [deleteEntryNo, setDeleteEntryNo] = useState(null);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [formMode, setFormMode] = useState('add');
    const [showGrid, setShowGrid] = useState(true);
    const [QualityCheckMaster, setQualityCheckMaster] = useState([]);
    const [QualityCheckEntries, setQualityCheckEntries] = useState([]);
    const [GrnProdEntries, setGrnProdEntries] = useState([]);
    const [itemMasterEntries, setItemMasterEntries] = useState([]);
    const [EmployeeMasterEntries, setEmployeeMasterEntries] = useState([]);

    useEffect(() => {
        fetchQualityCheck();
        fetchQualityEntry();
        fetchEmpMaster();
        fetchItemMaster();
        fetchGRNPRodEntry(['GRN', 'PROD', 'DESP']);
    }, []);

    useEffect(() => {
        if (formMode === 'add') {
            if (rows.length > 0 && rows.every(row => row.Remark === 'P')) {
                setQualityCheck('P');
            } else if (rows.length > 0 && rows.every(row => row.Remark === 'F')) {
                setQualityCheck('F');
            } else {
                setQualityCheck('');
            }
        }
    }, [rows]);

    const fetchGRNPRodEntry = async (flags) => {
        try {
            const flagsParam = Array.isArray(flags) ? flags.join(',') : flags;
            const response = await axios.get(`https://www.wingap.net.in/api/processentry/${flagsParam}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`);
            setGrnProdEntries(response.data);
            //console.log(response.data);
        } catch (error) {
            console.log('error:', error);
        }
    };

    const fetchQualityCheck = async () => {
        try {
            const response = await axios.get('https://www.wingap.net.in/api/qualcheck');
            setQualityCheckMaster(response.data);
        } catch (error) {
            console.log('error:', error);
        }
    };

    const fetchEmpMaster = async () => {
        try {
            const response = await axios.get('https://www.wingap.net.in/api/employee');
            setEmployeeMasterEntries(response.data.sort((a, b) => a.EmpCode - b.EmpCode));
        } catch (error) {
            console.log('error:', error);
        }
    };

    const fetchQualityEntry = async () => {
        try {
            const response = await axios.get(`https://www.wingap.net.in/api/qualEntry/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`);
            setQualityCheckEntries(response.data);
            const maxEntryNo = calculateMaxEntryNo(response.data);
            const nextEntryNo = maxEntryNo + 1;
            setEntryNo(nextEntryNo);
            //console.log(response.data);
        } catch (error) {
            console.log('error:', error);
        }
    };

    const calculateMaxEntryNo = (entries) => {
        let maxEntryNo = 0;
        for (const entry of entries) {
            if (entry.EntryNo > maxEntryNo) {
                maxEntryNo = entry.EntryNo;
            }
        }
        return maxEntryNo;
    };

    const fetchItemMaster = async () => {
        try {
            const response = await axios.get("https://www.wingap.net.in/api/items-master");
            setItemMasterEntries(response.data.sort((a, b) => a.ItCode - b.ItCode));
        } catch (error) {
            console.log("error:", error);
        }
    };

    const addProduct = async () => {
        if ((!props.canAdd)) {
              const action = "Save";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
        try {
            const productData = {
                EntryNo: Number(EntryNo),
                Flag: Flag,
                GRNEntryNo: GRNEntryNo,
                TrDate: TrDate,
                QCITCODE: Number(QcItCode),
                BatchNo: BatchNo,
                Manufacture: Manufacture,
                Expiry: Expiry,
                Qty: Qty,
                EmpCode: EmpCode,
                QualityCheck: QualityCheck,
                Narration: Narration,
                UserID: props.name,
                DeptCode: props.selectedDept,
                YearCode: props.selectedYear,
                CompCode: props.selectedCompany,
                items: rows,
            };
            
            //console.log(productData);

            await axios.post(`https://www.wingap.net.in/api/qualEntry/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, productData);
            toast.success('Quality Check Added Successfully....', { autoClose: 650 });
            setQcItCode(0);
            setFlag('');
            setGRNEntryNo('');
            setQualityCheck('');
            setManufacture('');
            setExpiry('');
            setQty('');
            setWeight('');
            setNarration('');
            setEmpCode('');
            setBatchNo('');
            setRows([{ Parameter: '', StartValue: '', Endvalue: '', ActualValue: '', Remark: '' }]);
            fetchQualityEntry();
            fetchGRNPRodEntry(['GRN', 'PROD', 'DESP']);
        } catch (error) {
            console.log('Error:', error);
        }
    };

    const updateProduct = async () => {
        if ((!props.canEdit)) {
              const action = "Update";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
        try {
            const updatedProductData = {
                EntryNo: Number(EntryNo),
                Flag: Flag,
                GRNEntryNo: GRNEntryNo,
                TrDate: TrDate,
                QCITCODE: Number(QcItCode),
                BatchNo: BatchNo,
                Qty: Qty,
                Manufacture: Manufacture,
                Expiry: Expiry,
                EmpCode: EmpCode,
                QualityCheck: QualityCheck,
                Narration: Narration,
                UserID: props.name,
                DeptCode: props.selectedDept,
                YearCode: props.selectedYear,
                CompCode: props.selectedCompany,
                items: rows,
            };

            //console.log(updatedProductData);


            await axios.put(`https://www.wingap.net.in/api/qualEntry/${EntryNo}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, updatedProductData);
            toast.success('Quality Check Updated Successfully....', { autoClose: 650 });
            setQcItCode(0);
            setFlag('');
            setGRNEntryNo('');
            setQualityCheck('');
            setManufacture('');
            setExpiry('');
            setQty(0);
            setWeight('');
            setNarration('');
            setEmpCode('');
            setBatchNo('');
            setRows([{ Parameter: '', StartValue: '', Endvalue: '', ActualValue: '', Remark: '' }]);
            setFormMode('add');
            fetchQualityEntry();
        } catch (error) {
            console.log('Error updating product:', error);
        }
    };

    const handleDeleteConfirmation = async () => {
        try {
            if (deleteEntryNo) {
                await deleteProduct(deleteEntryNo);
                setOpenConfirmation(false);
            }
        } catch (error) {
            console.log('Error:', error);
        }
    };

    const deleteProduct = async (QcCode) => {
        if (!props.canDelete) {
                  toast.error("You do not have permission to Delete.", { autoClose: 800 });
                  return;
                }
        try {
            await axios.delete(`https://www.wingap.net.in/api/qualEntry/${QcCode}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, {
                headers: {
                    'username': props.name,
                },
            });
            fetchQualityEntry();
        } catch (error) {
            console.log('Error:', error);
        }
    };

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    /* const setEditForm = (room, EntryNo, Flag, ItCode) => {
        // Set form mode
        //console.log(room, EntryNo, Flag);
        setFormMode('add');
        const GrnProd = GrnProdEntries.filter(entry => entry.EntryNo == EntryNo && entry.Flag === Flag && entry.ItCode == ItCode);
        console.log(GrnProd);
        setGRNEntryNo(GrnProd[0].EntryNo);
        setFlag(GrnProd[0].Flag);
        setQcItCode(GrnProd[0].ItCode);
        const formattedDate = new Date(GrnProd[0].TrDate).toISOString().split("T")[0];
        setTrDate(formattedDate);
        const formattedDate1 = new Date(GrnProd[0].Manufacture).toISOString().split("T")[0];
        const formattedDate2 = new Date(GrnProd[0].Expiry).toISOString().split("T")[0];
        setManufacture(formattedDate1);
        setExpiry(formattedDate2);
        setBatchNo(GrnProd[0].BatchNo);
        setNarration(GrnProd[0].Remark1);
        setEmpCode(GrnProd[0].EmpCode);
        if (GrnProd[0].QualityCheck === '' || GrnProd[0].QualityCheck === null) {
            const filteredEntries = QualityCheckMaster.filter(entry => entry.QCITCODE == GrnProd[0].ItCode);
            if (filteredEntries.length === 0) {
                showDuplicateEntryAlert();
                setRows([]);
                //return; 
            }
            const newRows = filteredEntries.map(filteredEntry => {
                return {
                    Parameter: filteredEntry.Parameter,
                    StartValue: filteredEntry.StdValue1,
                    Endvalue: filteredEntry.StdValue2,
                };
            });
            setRows(newRows);
            setShowGrid(false);
            fetchQualityEntry();
            fetchGRNPRodEntry(['GRN', 'PROD']);
        } else if (GrnProd[0].QualityCheck === 'P' || GrnProd[0].QualityCheck === 'F') {
            setFormMode('edit');
            const filteredEntries = QualityCheckEntries.filter(entry => entry.GRNEntryNo == EntryNo && entry.Flag === Flag);
            console.log(filteredEntries);
            const entry = filteredEntries[0];
            
            setGRNEntryNo(entry.GRNEntryNo);
            setEntryNo(entry.EntryNo);
            const formattedDate1 = new Date(entry.Manufacture).toISOString().split("T")[0];
            const formattedDate2 = new Date(entry.Expiry).toISOString().split("T")[0];
            setManufacture(formattedDate1);
            setExpiry(formattedDate2);
            setBatchNo(entry.Narration2 ? entry.Narration2 : '');
            setNarration(entry.Narration1 ? entry.Narration1 : '');
            setEmpCode(entry.EmpCode ? entry.EmpCode : '');
            const newRows = filteredEntries.map(filteredEntry => {
                return {
                    Parameter: filteredEntry.Parameter || '',
                    StartValue: filteredEntry.StdValue1 || '',
                    Endvalue: filteredEntry.StdValue2 || '',
                    ActualValue: filteredEntry.ActualValue || '',
                    Remark: filteredEntry.Remark || '',
                };
            });
            console.log(newRows)
            if (newRows && newRows.lentgh > 0) {
                setRows(newRows);
            } else {
                setRows([]);
            }
            setQualityCheck(filteredEntries[0].QualityCheck);
            console.log(GrnProd[0].QualityCheck, filteredEntries[0].QualityCheck);
            setShowGrid(false);
            fetchGRNPRodEntry(['GRN', 'PROD']);
            //fetchQualityEntry();
        } else {
            console.warn('No entries found in QualityCheckEntries for EntryNo:', GrnProd[0].EntryNo);
            setRows([]);
        }
    }; */

    const setEditForm = (room, EntryNo, Flag, ItCode) => {
        //console.log(room, EntryNo, Flag);
        setFormMode('add');
        const GrnProd = GrnProdEntries.filter(entry => entry.EntryNo == EntryNo && entry.Flag === Flag && entry.ItCode == ItCode);
        //console.log(GrnProd);
        setGRNEntryNo(GrnProd[0].EntryNo);
        setFlag(GrnProd[0].Flag);
        setQcItCode(GrnProd[0].ItCode);
        const formattedDate = new Date(GrnProd[0].TrDate).toISOString().split("T")[0];
        setTrDate(formattedDate);
        const formattedDate1 = new Date(GrnProd[0].Manufacture).toISOString().split("T")[0];
        const formattedDate2 = new Date(GrnProd[0].Expiry).toISOString().split("T")[0];
        setManufacture(formattedDate1);
        setExpiry(formattedDate2);
        if (GrnProd[0].Flag === 'PROD') {
            setBatchNo(GrnProd[0].ProdBatchNo);
        } else {
            setBatchNo(GrnProd[0].BatchNo);
        }
        setQty(GrnProd[0].Qty);
        setWeight(GrnProd[0].Weight);
        setNarration(GrnProd[0].Remark1);
        setEmpCode(GrnProd[0].EmpCode);
        if (GrnProd[0].QualityCheck === '' || GrnProd[0].QualityCheck === null) {
            const filteredEntries = QualityCheckMaster.filter(entry => entry.QCITCODE == GrnProd[0].ItCode);
            if (filteredEntries.length === 0) {
                showDuplicateEntryAlert();
                setRows([]);
                //return; 
            }
            const newRows = filteredEntries.map(filteredEntry => {
                return {
                    Parameter: filteredEntry.Parameter,
                    StartValue: filteredEntry.StdValue1,
                    Endvalue: filteredEntry.StdValue2,
                };
            });
            setRows(newRows);
            setShowGrid(false);
            fetchQualityEntry();
            fetchGRNPRodEntry(['GRN', 'PROD', 'DESP']);
        } else if (GrnProd[0].QualityCheck === 'P' || GrnProd[0].QualityCheck === 'F') {
            setFormMode('edit');

            const filteredEntries = QualityCheckEntries.filter(
                entry => entry.GRNEntryNo === EntryNo && entry.Flag === Flag
            );

            if (filteredEntries.length > 0) {
                const newRows = filteredEntries.map(({ Parameter, StdValue1, StdValue2, ActualValue, Remark }) => ({
                    Parameter: Parameter || '',
                    StartValue: StdValue1 || '',
                    Endvalue: StdValue2 || '',
                    ActualValue: ActualValue || '',
                    Remark: Remark || '',
                }));

                const allFieldsEmpty = newRows.every(row =>
                    !row.Parameter && !row.StartValue && !row.Endvalue && !row.ActualValue && !row.Remark
                );

                setRows(allFieldsEmpty ? [] : newRows);

                const {
                    QualityCheck,
                    GRNEntryNo,
                    EntryNo,
                    Manufacture,
                    Expiry,
                    Narration2,
                    Narration1,
                    EmpCode,
                } = filteredEntries[0];

                setQualityCheck(QualityCheck || '');
                setGRNEntryNo(GRNEntryNo || '');
                setEntryNo(EntryNo || '');
                setManufacture(Manufacture ? new Date(Manufacture).toISOString().split("T")[0] : '');
                setExpiry(Expiry ? new Date(Expiry).toISOString().split("T")[0] : '');
                setBatchNo(Narration2 || '');
                setNarration(Narration1 || '');
                setEmpCode(EmpCode || '');
            } else {
                // Clear fields when no valid entries are found
                setRows([]);
                setQualityCheck('');
                setBatchNo('');
                setNarration('');
                setEmpCode('');
            }

            setShowGrid(false);
            fetchGRNPRodEntry(['GRN', 'PROD', 'DESP']);
        }
    };

    const handleSaveProduct = async () => {
        if (formMode === 'add') {
            await addProduct();
        } else if (formMode === 'edit') {
            await updateProduct();
        }
    };

    const resetForm = () => {
        setManufacture('');
        setExpiry('');
        setNarration('');
        setEmpCode('');
        setBatchNo('');
        setRows([{ RawItCode: 0, Qty: 0.0, PerKg: '' }]);
    };

    const handleshowandhide = () => {
        setFormMode('add');
        setShowGrid(!showGrid);
        setUnits(units);
        setQcItCode('');
        fetchQualityEntry();
        fetchGRNPRodEntry(['GRN', 'PROD', 'DESP']);
        setRows([{ Parameter: '', StartValue: '', Endvalue: '', ActualValue: '', Remark: '' }]);
    };

    const handleCancel = () => {
        try {
            handleshowandhide();
        } catch (error) {
            console.log('Error:', error);
        }
    };

    const componentPDF = useRef();

    const generatePDF = useReactToPrint({
        content: () => componentPDF.current,
        documentTitle: "Caste Data",
        onAfterPrint: () => alert("Pdf downloaded"),
        pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
    });

    /*  const handleRowChange = (index, field, value) => {
         const updatedRows = rows.map((row, i) => {
             if (i === index) {
                 return { ...row, [field]: value };
             }
             return row;
         });
         setRows(updatedRows);
     }; */

    /* const handleRowChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
 
        const actualValue = parseFloat(updatedRows[index].ActualValue);
        const startValue = parseFloat(updatedRows[index].StartValue);
        const endValue = parseFloat(updatedRows[index].Endvalue);
 
        const isInRange = actualValue >= startValue && actualValue <= endValue;
 
        if (isInRange) {
            updatedRows[index].Remark = "P";
        }  else {
            updatedRows[index].Remark = "";
        } 
        setRows(updatedRows);
    }; */

    const handleRowChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;

        if (field === 'ActualValue') {
            const actualValue = parseFloat(value);
            const startValue = parseFloat(updatedRows[index].StartValue);
            const endValue = parseFloat(updatedRows[index].Endvalue);

            const isInRange = actualValue >= startValue && actualValue <= endValue;
            updatedRows[index].Remark = isInRange ? "P" : "F";
        } else if (field === 'Remark') {
            updatedRows[index].Remark = value;
        }

        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([...rows, { Parameter: '', StartValue: '', Endvalue: '', ActualValue: '', Remark: '' }]);
    };

    const removeRow = (index) => {
        const newRows = rows.filter((_, i) => i !== index);
        setRows(newRows);
    };

    return (
        <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
            <ToastContainer />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <h1 style={{ fontSize: '24px', margin: 0 }}>Quality Check Entry -<span style={{ marginLeft: '10px', color: 'red' }}>{ShowEntries ? 'Pending Entries' : 'All Entries'}</span></h1>

                <div style={{ display: 'flex' }}>
                    {showGrid && <Grid item>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setShowEntries(prevState => !prevState);
                                fetchGRNPRodEntry(['GRN', 'PROD', 'DESP']);
                            }}
                            sx={{ backgroundColor: ShowEntries ? 'blue' : '#4caf50', color: "white", marginRight: "10px", }}
                        >
                            {!ShowEntries ? 'SHOW PENDING' : 'SHOW ALL'}
                        </Button>
                    </Grid>}
                    {showGrid && (
                        <Button
                            variant="contained"
                            onClick={generatePDF}
                            sx={{ backgroundColor: "yellow", color: "black", marginLeft: "10px", '&:hover': { color: "white" } }}
                        >
                            Download PDF
                        </Button>
                    )}
                    {showGrid && (
                        <Button
                            variant="contained"
                            sx={{ backgroundColor: "yellow", color: "black", marginLeft: "10px", '&:hover': { color: "white" } }}
                        >
                            Export
                        </Button>
                    )}
                    {!showGrid && <Grid item>
                        <Button
                            variant="contained"
                            className="view-button"
                            onClick={handleshowandhide}
                            sx={{ backgroundColor: 'blue', color: "white", marginBottom: "4px", float: 'right' }}
                        >
                            Back
                        </Button>
                    </Grid>}
                </div>
            </div>

            {!showGrid && (
                <>
                    <div style={{ maxWidth: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px', backgroundColor: '#DEDADA', borderRadius: '5px', color: '#333', padding: '5px', width: '100%' }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '2px' }}>
                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="Flag" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        Flag
                                    </label>
                                    <input
                                        type="text"
                                        value={Flag}
                                        readOnly
                                        placeholder="Flag"
                                        style={{ padding: '5px', width: '80px' }}
                                    />
                                </div>

                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="EntryNo" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        EntryNo
                                    </label>
                                    <input
                                        type="number"
                                        value={EntryNo}
                                        readOnly
                                        placeholder="EntryNo"
                                        style={{ padding: '5px', width: '80px' }}
                                    />
                                </div>

                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="GRNEntryNo" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        GRNEntryNo
                                    </label>
                                    <input
                                        type="number"
                                        value={GRNEntryNo}
                                        readOnly
                                        placeholder="GRNEntryNo"
                                        style={{ padding: '5px', width: '80px' }}
                                    />
                                </div>

                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="TrDate" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>TrDate</label>
                                    <input
                                        type="date"
                                        value={TrDate}
                                        readOnly
                                        onChange={(e) => setTrDate(e.target.value)}
                                        placeholder="TrDate"
                                        style={{ padding: '5px', width: '110px' }}
                                    />
                                </div>

                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="QcItCode" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        QcItCode
                                    </label>
                                    <Autocomplete
                                        options={itemMasterEntries}
                                        readOnly
                                        getOptionLabel={(option) => option.ItName || ''}
                                        value={itemMasterEntries.find((item) => item.ItCode == QcItCode) || null}
                                        onChange={(event, newValue) => {
                                            if (newValue) {
                                                setQcItCode(newValue.ItCode);
                                            } else {
                                                setQcItCode('');
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="QcItCode"
                                                readOnly
                                                sx={{
                                                    marginBottom: '1px',
                                                    width: '264px',
                                                    '& .MuiInputBase-input': { color: 'black', padding: '1px', height: '1px' },
                                                    '& .MuiInputLabel-root': { color: 'black' },
                                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
                                                    '& .MuiSvgIcon-root': { color: 'black' },
                                                    backgroundColor: 'white',
                                                }}
                                            />
                                        )}
                                        sx={{ width: '264px' }}
                                        isOptionEqualToValue={(option, value) => option.ItCode === value.ItCode}
                                    />
                                </div>

                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="Qty" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        Qty
                                    </label>
                                    <input
                                        type="text"
                                        value={Qty}
                                        readOnly
                                        onChange={(e) => setQty(e.target.value)}
                                        placeholder="Qty"
                                        style={{ padding: '5px', width: '110px' }}
                                    />
                                </div>

                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="Qty" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        Weight
                                    </label>
                                    <input
                                        type="text"
                                        value={Weight}
                                        readOnly
                                        onChange={(e) => setWeight(e.target.value)}
                                        placeholder="Qty"
                                        style={{ padding: '5px', width: '110px' }}
                                    />
                                </div>  

                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="BatchNo" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        BatchNo
                                    </label>
                                    <input
                                        type="text"
                                        value={BatchNo}
                                        readOnly
                                        onChange={(e) => setBatchNo(e.target.value)}
                                        placeholder="BatchNo"
                                        style={{ padding: '5px', width: '110px' }}
                                    />
                                </div>

                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="Manufacturing" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        Manufacturing
                                    </label>
                                    <input
                                        type="date"
                                        value={Manufacture}
                                        onChange={(e) => setManufacture(e.target.value)}
                                        placeholder="Manufacturing"
                                        style={{ padding: '5px', width: '110px' }}
                                    />
                                </div>
                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="Expiry" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        Expiry
                                    </label>
                                    <input
                                        type="date"
                                        value={Expiry}
                                        onChange={(e) => setExpiry(e.target.value)}
                                        placeholder="Expiry"
                                        style={{ padding: '5px', width: '110px' }}
                                    />
                                </div>
                                <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="EmpCode" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        EmpCode
                                    </label>
                                    <select
                                        value={EmpCode}
                                        onChange={(e) => {
                                            const selectedGroupName = e.target.value;
                                            setEmpCode(selectedGroupName);
                                            const selectedGroup = EmployeeMasterEntries.find(group => group.EmpCode == selectedGroupName);
                                            if (selectedGroup) {
                                                setEmpCode(selectedGroup.EmpCode);
                                            }
                                        }}
                                        style={{ padding: '5px', width: '160px' }}
                                    >
                                        {EmployeeMasterEntries.map((group) => (
                                            <option key={group.EmpCode} value={group.EmpCode}>{group.EmpName}</option>
                                        ))}
                                    </select>
                                </div>
                                {/* <div style={{ marginRight: '4px' }}>
                                    <label htmlFor="Narration" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        Narration
                                    </label>
                                    <input
                                        type="text"
                                        value={Narration}
                                        readOnly
                                        onChange={(e) => setNarration(e.target.value)}
                                        placeholder="Narration"
                                        style={{ padding: '5px', width: '160px' }}
                                    />
                                </div> */}
                                <div style={{ flex: '1 1 160px', minWidth: '160px' }}>
                                    <label htmlFor="Narration" style={{ display: 'block', marginBottom: '2px', textAlign: 'left' }}>
                                        Narration
                                    </label>
                                    <input
                                        type="text"
                                        value={Narration}
                                        readOnly
                                        onChange={(e) => setNarration(e.target.value)}
                                        placeholder="Narration"
                                        style={{ padding: '5px', width: '100%' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        overflow: 'auto',
                        maxHeight: '380px',
                        width: '100%',
                        margin: '20px auto',
                        padding: '10px',
                        borderRadius: '5px',
                        /* backgroundColor: '#DEDADA', */
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'
                    }}>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            border: '1px solid #333',
                            tableLayout: 'fixed'
                        }}>
                            <thead style={{ backgroundColor: '#5B8FB9', position: 'sticky', top: 0, zIndex: 10 }}>
                                <tr>
                                    <th style={{ width: '70px', border: '1px solid white', color: 'white', padding: '6px', textAlign: 'center' }}>SrNo.</th>
                                    <th style={{ border: '1px solid white', color: 'white', padding: '6px' }}>Parameter</th>
                                    <th style={{ border: '1px solid white', color: 'white', padding: '6px' }}>StartValue</th>
                                    <th style={{ border: '1px solid white', color: 'white', padding: '6px' }}>EndValue</th>
                                    <th style={{ border: '1px solid white', color: 'white', padding: '6px' }}>ActualValue</th>
                                    <th style={{ border: '1px solid white', color: 'white', padding: '6px' }}>Remark</th>
                                    <th style={{ width: '120px', border: '1px solid white', color: 'white', padding: '6px', textAlign: 'center' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={index}>
                                        <td style={{ width: '70px', border: '1px solid #333', padding: '4px', textAlign: 'center' }}>{index + 1}</td>
                                        <td style={{ border: '1px solid #333', padding: '4px' }}>
                                            <input
                                                type="text"
                                                value={row.Parameter}
                                                readOnly
                                                placeholder="Parameter"
                                                style={{ padding: '5px', width: '100%', border: 'none' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '4px' }}>
                                            <input
                                                type="text"
                                                value={row.StartValue}
                                                readOnly
                                                placeholder="StartValue"
                                                style={{ padding: '5px', width: '100%', border: 'none' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '4px' }}>
                                            <input
                                                type="text"
                                                value={row.Endvalue}
                                                readOnly
                                                placeholder="Endvalue"
                                                style={{ padding: '5px', width: '100%', border: 'none' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '4px' }}>
                                            <input
                                                type="text"
                                                value={row.ActualValue}
                                                onChange={(e) => handleRowChange(index, 'ActualValue', e.target.value)}
                                                placeholder="ActualValue"
                                                style={{ padding: '5px', width: '100%', border: 'none' }}
                                            />
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '4px' }}>
                                            <select
                                                value={row.Remark}
                                                onChange={(e) => handleRowChange(index, 'Remark', e.target.value)}
                                                style={{ padding: '5px', width: '100%', border: 'none' }}
                                            >
                                                <option value="">Select</option>
                                                <option value="P">Passed</option>
                                                <option value="F">Fail</option>
                                            </select>
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '4px', textAlign: 'center', width: '120px' }}>
                                            <IconButton onClick={() => removeRow(index)} aria-label="delete">
                                                <DeleteIcon sx={{ color: 'red' }} />
                                            </IconButton>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={Object.keys(rows[0] || {}).length + 1} style={{ textAlign: "left", padding: "2px", border: "1px solid #333" }}>
                                        <button
                                            onClick={addRow}
                                            style={{
                                                backgroundColor: "white",
                                                color: "black",
                                                padding: "4px 12px",
                                                border: "none",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px",
                                            }}
                                        >
                                            ➕ Add Row
                                        </button>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div style={{
                        display: 'flex', justifyContent: 'space-between', backgroundColor: '#DEDADA', margin: '20px auto',
                        padding: '10px', marginTop: '10px'
                    }}>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            {/* <Button
                                type="button"
                                onClick={addRow}
                                style={{
                                    backgroundColor: "#1160AA",
                                    color: "white",
                                    fontWeight: "bold",
                                    padding: "8px 20px",
                                    fontSize: '12px',
                                    width: "auto",
                                    cursor: 'pointer',
                                }}
                            >
                                Add Row
                            </Button> */}
                            <Button
                                className={formMode === 'add' ? 'add-button' : 'update-button'}
                                onClick={handleSaveProduct}
                                style={{
                                    padding: '8px 20px',
                                    fontSize: '16px',
                                    fontWeight: "bold",
                                    backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                                    color: 'white',
                                    border: 'none',
                                    cursor: 'pointer',
                                    marginBottom: '4px',
                                    marginLeft: '10px',
                                }}
                            >
                                {formMode === 'add' ? 'Save' : 'Update'}
                            </Button>
                            <Button
                                className="view-button"
                                onClick={handleCancel}
                                style={{
                                    padding: '8px 20px',
                                    fontSize: '16px',
                                    fontWeight: "bold",
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    border: 'none',
                                    cursor: 'pointer',
                                    marginBottom: '4px',
                                }}
                            >
                                Exit
                            </Button>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <label style={{ fontWeight: 'bold' }}>Quality Check:</label>
                            <select
                                value={QualityCheck}
                                onChange={(e) => setQualityCheck(e.target.value)}
                                style={{
                                    padding: '8px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                    outline: 'none',
                                    fontSize: '14px',
                                    backgroundColor: 'yellow',
                                    width: '160px',
                                }}
                            >
                                <option value="">Select</option>
                                <option value="P">Passed</option>
                                <option value="F">Fail</option>
                            </select>
                        </div>

                    </div>
                </>
            )}
            {showGrid && (
                <div ref={componentPDF} style={{ width: '100%' }}>
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            border: '1px solid #ccc',
                        }}
                    >
                        <thead>
                            <tr style={{ background: '#f2f2f2', color: 'black' }}>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    SrNo.
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    Flag
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    EntryNo
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    TrDate
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    ItName
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    QualityCheck
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                    className="print-hide"
                                >
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {GrnProdEntries.filter((caste) => {
                                if (ShowEntries) {
                                    return !caste.QualityCheck || caste.QualityCheck.trim() === '' || caste.QualityCheck.trim() === null;
                                } else {
                                    return true;
                                }
                            })
                                .filter((caste) => {
                                    return caste.Flag === 'PROD' || true;
                                })
                                .reduce((accumulator, current) => {
                                    if (current.Flag === 'PROD') {
                                        if (!accumulator.some(item => item.EntryNo == current.EntryNo && item.Flag === current.Flag)) {
                                            accumulator.push(current);
                                        }
                                    } else {
                                        accumulator.push(current);
                                    }
                                    return accumulator;
                                }, [])
                                .sort((a, b) => {
                                    const dateA = new Date(a.TrDate);
                                    const dateB = new Date(b.TrDate);
                                    if (dateA > dateB) return -1;
                                    if (dateA < dateB) return 1;
                                    if (a.EntryNo > b.EntryNo) return -1;
                                    if (a.EntryNo < b.EntryNo) return 1;
                                    return 0;
                                }).map((caste, index) => {
                                    //console.log('grnentries',caste);
                                    const selectedGroup = itemMasterEntries.find(group => group.ItCode == caste.ItCode);
                                    return (
                                        <tr style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                                            <td style={{ padding: '6px', border: '1px solid #ccc', width: '10%' }}>{index + 1} </td>
                                            <td style={{ padding: '6px', border: '1px solid #ccc' }}>{caste.Flag}</td>
                                            <td style={{ padding: '6px', border: '1px solid #ccc', width: '12%' }}>{caste.EntryNo}</td>
                                            <td style={{ padding: '6px', border: '1px solid #ccc', width: '12%' }}>{new Date(caste.TrDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                                            <td style={{ padding: '6px', border: '1px solid #ccc' }}>{selectedGroup ? `${selectedGroup.ItName}` : ''} </td>
                                            <td style={{ padding: '6px', border: '1px solid #ccc' }}>{caste.QualityCheck === 'P' ? 'Passed' : caste.QualityCheck === 'F' ? 'Fail' : ''} </td>

                                            <td className="print-hide" style={{ padding: '4px', border: '1px solid #ccc' }}>
                                                {(props.canAdd === true) && (<button
                                                    className='action-btn btn-edit'
                                                    onClick={() => setEditForm(caste, caste.EntryNo, caste.Flag, caste.ItCode)}
                                                >
                                                    Add
                                                </button>)}
                                                {/* <button
                                                style={{
                                                    padding: '5px 10px',
                                                    backgroundColor: 'rgb(244, 67, 54)',
                                                    color: 'white',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                }}
                                                //onClick={() => deleteProduct(caste.QcCode)}
                                                onClick={() => {
                                                    setDeleteEntryNo(caste.QCCODE);
                                                    setOpenConfirmation(true);
                                                }}
                                            >
                                                Delete
                                            </button> */}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                </div>
            )}
            {<Dialog
                open={openConfirmation}
                onClose={() => setOpenConfirmation(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"CONFIRM DELETE"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to DELETE this Entry ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                        Cancel
                    </Button>
                    <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>}
        </div>
    );
}
export default QualityCheckEntry;